import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';
/**
 * Based on code from "Twitter Bootstrap Modals and Knockout.js"
 * http://aboutcode.net/2012/11/15/twitter-bootstrap-modals-and-knockoutjs.html
 */



var instance = null;

function ModalDialog() {
    if (instance !== null) {
        throw new Error('Cannot instantiate more than one ModalDialog. Call ModalDialog.getInstance().');
    }
}

function addTemplateToBody(template) {
    var $div = $('<div id="modal-dialog-container" style="display: none">' + template + '</div>');
    $('body').prepend($div);
    return $div[0];
}

function createModalElement(template, viewModel) {
    // renderTemplate wants the name (e.g. id) of the template to find it in the DOM and
    // do its thing. So we add it to our target so it can get it from there.
    var modalContainer = addTemplateToBody(template);
    var deferredElement = new Promise(function(resolve, reject) {
        ko.renderTemplate(
            modalContainer.id,  // ID of the template to render
            viewModel,          // view model to data bind to the template
            {
                // Need to know when template has rendered to get resulting DOM element
                afterRender: function(nodes) {
                    // ignore #text nodes before and after the modal element
                    var elements = _.filter(nodes, function(node) {
                        return node.nodeType === Node.ELEMENT_NODE;
                    });
                    resolve(elements[0]);
                }
            },
            modalContainer,     // where to render the template
            'replaceNode'       // renderMode: target element will be replaced by template
        );
        // return deferred element so callers can wait until element is ready to use
    });
    return deferredElement;
}

function createModalHelper(resolve, reject, context) {
    return {
        close: _.debounce(function(result) {
            if (_.isNil(result)) {
                // Reject
                reject();
            } else {
                resolve(result);
            }
        }, 100)
    };
}

ModalDialog.prototype = {
    /**
     * showModal - Dynamically creates and shows a modal dialog. Template can be passed in
     * the options.viewModel or in the options object.
     *
     * @params {object} options
     * @params {object} options.viewModel - Knockout view-model object for the modal dialog.
     * @params {object} options.viewModel.template - Knockout template for the modal dialog.
     * @params {object} options.template - Knockout template for the modal dialog.
     * @params {object} options.context - Context to be used by callback functions.
     */
    showModal: function(options) {
        if (_.isEmpty(options)) {
            throw new Error('ModalDialog::showModal - Missing required argument \'options\'');
        }
        if (!_.isObject(options.viewModel)) {
            throw new Error('ModalDialog::showModal - options.viewModel is required');
        }

        var viewModel = options.viewModel;
        var template = options.template || viewModel.template;
        var context = options.context;

        if (_.isEmpty(template)) {
            throw new Error('ModalDialog::showModal - options.template or options.viewModel.template is required');
        }

        let jqueryElement;

        // return deferred element
        let deferredModalResult = new Promise(function(resolve, reject) {
            createModalElement(template, viewModel).then(function(element){
                jqueryElement = $(element);
                // provide a way for viewModel to close modal and pass data back
                viewModel.modal = createModalHelper(resolve, reject, context);
                // show modal element
                jqueryElement.modal({
                    // prevent closing of modal from clicking on background or pressing ESC
                    backdrop: 'static',
                    keyboard: false
                });
                // clean up DOM when modal is hidden
                jqueryElement.on('hidden.bs.modal', function() {
                    // clean up knockout bindings before removing element to prevent memory leaks
                    jqueryElement.each(function(index, element) { ko.cleanNode(element); });
                    jqueryElement.remove(); // remove the DOM element
                });
            });
        }).finally(function() {
            // hide modal when dismised
            jqueryElement.modal('hide');
        });
        return deferredModalResult;
    }
};

ModalDialog.getInstance = function() {
    if (instance === null) {
        instance = new ModalDialog();
    }
    return instance;
};

export default ModalDialog.getInstance();
